import {
  PostBannerRequestBody,
  GetBannerRequestParams,
  GetBannerByIdRequestParams,
  PutBannerByIdRequestBody,
  PutBannerOrderNumberRequestBody,
  DeleteBannerByIdRequestBody,
} from '@/src/apis/rest/banner.dtos';
import { BannerDto } from '@/src/models/BannerDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import request from '@/src/apis/axios';
import { plainToInstance } from 'class-transformer';

const URL = {
  banner: '/admin/banners',
  bannerDetail: '/admin/banners/{id}',
  bannerOrderNumber: '/admin/banners/bannerOrderNumber',
  bannerContentCategory: '/admin/banners/content-obj-list',
  bannerPageContentCategory: '/admin/banners/app-page-obj-list',
};

// 배너 리스트 조회
export const getBannerAPI = async (
  requestParams: Partial<GetBannerRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<BannerDto>>({
    method: 'get',
    url: URL.banner,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(BannerDto, data.rows);

  return { rows, count: data.count };
};

// 배너 상세 조회
export const getBannerByIdAPI = async (
  requestParams: GetBannerByIdRequestParams,
) => {
  const { id } = requestParams;

  const { data } = await request<ObjectResponse<BannerDto>>({
    method: 'get',
    url: URL.bannerDetail.replace('{id}', String(id)),
  });

  return plainToInstance(BannerDto, data.row);
};

// 배너 생성
export const postBannerAPI = async (requestBody: PostBannerRequestBody) => {
  const { data } = await request<ObjectResponse<BannerDto>>({
    method: 'post',
    url: URL.banner,
    requestBody: { ...requestBody },
  });

  return plainToInstance(BannerDto, data.row);
};

// 배너 수정
export const putBannerByIdAPI = async (
  requestBody: PutBannerByIdRequestBody,
) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<BannerDto>>({
    method: 'put',
    url: URL.bannerDetail.replace('{id}', String(id)),
    requestBody: { ...rest, serviceType: 'EARTH_APP' },
  });

  return plainToInstance(BannerDto, data.row);
};

// 배너 삭제
export const delteBannerByIdAPI = async ({
  id,
}: DeleteBannerByIdRequestBody) => {
  const { data } = await request<ObjectResponse<BannerDto>>({
    method: 'delete',
    url: URL.bannerDetail.replace('{id}', String(id)),
  });

  return plainToInstance(BannerDto, data.row);
};

// 배너 순서 변경
export const putBannerOrderNumberAPI = async (
  requestBody: PutBannerOrderNumberRequestBody,
) => {
  const { data } = await request<ObjectResponse<BannerDto>>({
    method: 'put',
    url: URL.bannerOrderNumber,
    requestBody,
  });

  return plainToInstance(BannerDto, data.row);
};

// 배너 컨텐츠 필터 카테고리 조회
export const getBannerContentCatetoryAPI = async () => {
  const { data } = await request<
    ListResponse<{ key: string; value: string; keyword: string }>
  >({
    method: 'get',
    url: URL.bannerContentCategory,
  });

  return data;
};

// 배너 앱 페이지 카테고리 조회
export const getBannerPageContentCatetoryAPI = async () => {
  const { data } = await request<
    ListResponse<{ key: string; value: string; keyword: string }>
  >({
    method: 'get',
    url: URL.bannerPageContentCategory,
  });

  return data;
};
